import React from 'react';
import { useParams } from 'react-router-dom';

import LogoSauter from '../../../assets/images/logo_sauter.png';
import LogoTherpac from '../../../assets/images/logo_thermor.png';
import LogoAtlantic from '../../../assets/images/logo_atlantic.svg';
import { T } from '~/components/Translations.js';

export default function Logo(props) {
    const params = useParams();

    const getLogo = () => {
        let logo = null;

        switch (params.universe?.toLowerCase()) {
            case 'sauter':
            case undefined:
                logo = LogoSauter;
                break;
            case 'therpac':
                logo = LogoTherpac;
                break;
            case 'atlantic':
            case 'acv':
            case 'afbg':
                logo = LogoAtlantic;
                break;
            default:
                break;
        }

        return logo;
    }

    return <>
            <toolbar logo="logo" {...(props.is_work_order ? {"is_work_order":"is_work_order"} : {})}>
                <img src={getLogo()} alt="logo"/>
                
            </toolbar>
            {props.is_work_order && 
                    <toolbar panier_extern="panier_extern">
                        <T>text.panier_extern_intervention</T>
                        </toolbar>
                    }
    </>
}